import DialogStepsWrapper from './DialogStepsWrapper';
import DialogStep from './DialogStep';

const DialogSteps = {
  Wrapper: DialogStepsWrapper,
  Step: DialogStep
};

export default DialogSteps;
